import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      fleets: 'Fleets',
      contact: 'Contact',
      admin: 'Admin',
    },
    // Hero Section
    hero: {
      title: 'Your Trusted Maritime Partner',
      subtitle: 'Providing premier ship agency services across all Turkish ports since 1990',
      cta: 'Get Started',
      secondary: 'Learn More',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive maritime solutions for every vessel type',
      shipAgency: {
        title: 'Ship Agency',
        description: 'Full port agency services including customs clearance, crew changes, and vessel operations support.',
      },
      cruiseAgency: {
        title: 'Cruise Agency',
        description: 'Specialized cruise ship services with passenger handling and shore excursion coordination.',
      },
      yachtAgency: {
        title: 'Yacht Agency',
        description: 'Premium yacht services including berthing arrangements, provisioning, and concierge services.',
      },
      shipSupply: {
        title: 'Ship Supply',
        description: 'Complete ship chandlery services with technical stores, provisions, and spare parts delivery.',
      },
    },
    // About
    about: {
      title: 'About Rota Maritime Agency',
      subtitle: 'Three Decades of Maritime Excellence',
      description: 'Founded in 1990 by the Levend family, Rota Maritime Agency is a leading maritime agency providing ship agency, Cruise ship agency, and yacht agency services across Turkey. With decades of experience in the maritime industry, we are committed to delivering high-quality, reliable, and efficient services to our clients.',
      history: 'Headquartered in Sinop, Rota Maritime Agency has built a strong reputation based on professionalism, expertise, and customer satisfaction. Our dedicated team ensures seamless operations for vessels, cruise ship, and yacht owners, offering comprehensive agency services at all major ports throughout Turkey.',
      mission: {
        title: 'Our Mission',
        text: 'At Rota Maritime Agency, our mission is to facilitate smooth and efficient maritime operations, ensuring that every client receives personalized and expert service. Whether it\'s commercial shipping, passenger cruise handling, or luxury yacht support, we are here to provide the best solutions with our deep industry knowledge and extensive network.',
      },
      vision: {
        title: 'Our Vision',
        text: 'With a passion for the sea and a commitment to excellence, Rota Maritime Agency continues to be a trusted partner in the maritime industry. Join us as we navigate towards a future of innovation and seamless maritime services.',
      },
      stats: {
        vessels: 'Vessels Served',
        ports: 'Ports Covered',
        years: 'Years Experience',
        clients: 'Happy Clients',
      },
    },
    // Fleets
    fleets: {
      title: 'Our Fleet Partners',
      subtitle: 'Trusted by leading vessel operators worldwide',
      viewDetails: 'View Details',
      specs: 'Specifications',
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        company: 'Company Name',
        phone: 'Phone Number',
        service: 'Service Type',
        message: 'Your Message',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Failed to send message. Please try again.',
      },
      info: {
        address: 'Address',
        addressText: 'Kemeraltı Cad. No: 45, Karaköy, Istanbul, Turkey',
        phone: 'Phone',
        email: 'Email',
        hours: 'Working Hours',
        hoursText: '24/7 Operations Center',
      },
      social: 'Follow Us',
    },
    // Footer
    footer: {
      description: 'Premier ship agency services across all Turkish ports.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved.',
    },
    // Admin
    admin: {
      title: 'Admin Panel',
      fleets: 'Manage Fleets',
      messages: 'Contact Messages',
      addFleet: 'Add New Fleet',
      editFleet: 'Edit Fleet',
      deleteConfirm: 'Are you sure you want to delete this item?',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
    },
  },
  ru: {
    // Navigation
    nav: {
      home: 'Главная',
      about: 'О нас',
      fleets: 'Флот',
      contact: 'Контакты',
      admin: 'Админ',
    },
    // Hero Section
    hero: {
      title: 'Ваш Надежный Морской Партнер',
      subtitle: 'Предоставляем первоклассные агентские услуги во всех портах Турции с 1990 года',
      cta: 'Начать',
      secondary: 'Подробнее',
    },
    // Services
    services: {
      title: 'Наши Услуги',
      subtitle: 'Комплексные морские решения для любого типа судов',
      shipAgency: {
        title: 'Судовое Агентство',
        description: 'Полный спектр портовых агентских услуг, включая таможенное оформление, смену экипажа и поддержку судовых операций.',
      },
      cruiseAgency: {
        title: 'Круизное Агентство',
        description: 'Специализированные услуги для круизных судов с обслуживанием пассажиров и координацией береговых экскурсий.',
      },
      yachtAgency: {
        title: 'Яхтенное Агентство',
        description: 'Премиальные услуги для яхт, включая организацию стоянки, снабжение и консьерж-сервис.',
      },
      shipSupply: {
        title: 'Судовое Снабжение',
        description: 'Полный комплекс услуг по снабжению судов техническими запасами, провизией и запасными частями.',
      },
    },
    // About
    about: {
      title: 'О Rota Maritime Agency',
      subtitle: 'Три Десятилетия Морского Мастерства',
      description: 'Основанное в 1990 году семьей Левенд, агентство Rota Maritime Agency является ведущим морским агентством, предоставляющим услуги судового агентирования, круизного агентирования и яхтенного агентирования по всей Турции. С многолетним опытом работы в морской отрасли мы стремимся предоставлять высококачественные, надежные и эффективные услуги нашим клиентам.',
      history: 'Штаб-квартира в Синопе, агентство Rota Maritime Agency построило прочную репутацию, основанную на профессионализме, экспертизе и удовлетворенности клиентов. Наша преданная команда обеспечивает бесперебойную работу для судов, круизных лайнеров и яхт, предлагая комплексные агентские услуги во всех крупных портах Турции.',
      mission: {
        title: 'Наша Миссия',
        text: 'Миссия Rota Maritime Agency - содействовать плавным и эффективным морским операциям, гарантируя каждому клиенту персонализированное и экспертное обслуживание. Будь то коммерческие перевозки, обслуживание пассажирских круизов или поддержка роскошных яхт, мы готовы предложить лучшие решения благодаря глубоким отраслевым знаниям и обширной сети.',
      },
      vision: {
        title: 'Наше Видение',
        text: 'С страстью к морю и стремлением к совершенству, Rota Maritime Agency продолжает оставаться надежным партнером в морской отрасли. Присоединяйтесь к нам на пути к будущему инноваций и безупречных морских услуг.',
      },
      stats: {
        vessels: 'Обслужено Судов',
        ports: 'Охвачено Портов',
        years: 'Лет Опыта',
        clients: 'Довольных Клиентов',
      },
    },
    // Fleets
    fleets: {
      title: 'Наши Партнеры по Флоту',
      subtitle: 'Нам доверяют ведущие судовладельцы мира',
      viewDetails: 'Подробнее',
      specs: 'Характеристики',
    },
    // Contact
    contact: {
      title: 'Свяжитесь с Нами',
      subtitle: 'Обратитесь к нашей команде',
      form: {
        name: 'Полное Имя',
        email: 'Электронная Почта',
        company: 'Название Компании',
        phone: 'Телефон',
        service: 'Тип Услуги',
        message: 'Ваше Сообщение',
        submit: 'Отправить',
        sending: 'Отправка...',
        success: 'Сообщение успешно отправлено!',
        error: 'Не удалось отправить сообщение. Попробуйте снова.',
      },
      info: {
        address: 'Адрес',
        addressText: 'Kemeraltı Cad. No: 45, Karaköy, Стамбул, Турция',
        phone: 'Телефон',
        email: 'Эл. почта',
        hours: 'Часы Работы',
        hoursText: 'Операционный центр 24/7',
      },
      social: 'Следите за нами',
    },
    // Footer
    footer: {
      description: 'Первоклассные агентские услуги во всех портах Турции.',
      quickLinks: 'Быстрые Ссылки',
      services: 'Услуги',
      contact: 'Контакты',
      rights: 'Все права защищены.',
    },
    // Admin
    admin: {
      title: 'Панель Администратора',
      fleets: 'Управление Флотом',
      messages: 'Сообщения',
      addFleet: 'Добавить Судно',
      editFleet: 'Редактировать',
      deleteConfirm: 'Вы уверены, что хотите удалить этот элемент?',
      save: 'Сохранить',
      cancel: 'Отмена',
      delete: 'Удалить',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('rotaship-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('rotaship-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ru' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
